import { createUseStyles } from "react-jss";

export const useStyles = createUseStyles({
  container: {
    "& svg": {
      transform: "none !important"
    }
  }
});
